// strict mode disabled to avoid exceptions inside MSIE-specific functions
// 'use strict';

var App = require('app');
var ChartExportOptionsView = require('components/devices/views/common/chart_export_options_view');
var ChartsPlugin = require('utils/charts/charts_plugin');
var Misc = require('utils/misc');
var i18n = require('utils/i18n');

var ChartsExport = ChartsPlugin.extend({
    textHeight: 10,
    minSecondsPerPoint: 15,
    maxSecondsPerBatch: 120000,
    completeCanvas: undefined,
    minWidth: 2048,
    minHeight: 1365,
    canExportChecked: undefined,
    headingHeight: 50,
    headingMargin: 10,
    headingFont: '20px Arial',
    ui: {
        btnSave: '.js-chart-export',
        btnSaveCSV: '.js-chart-export-csv',
    },
    initPlugin: function () {
        var self = this;
        $(this.ui.btnSave).on('click', function () {
            var dlg = new ChartExportOptionsView({
                caption: self.getCaption(),
                onSubmit: function (caption) {
                    App.hideModal(dlg);
                    self.caption = caption;
                    self.export();
                },
            });

            App.showModal(dlg);
        });
        $(this.ui.btnSaveCSV).on('click', function () {
            self.exportCSV();
        });
        this.toggleEnabled();

        this.chartView.on('charts:draw:after', function () {
            self.toggleEnabled();
        });
    },

    canExport: function () {
        if (this.canExportChecked === undefined) {
            this.canExportChecked = (navigator && navigator.msSaveBlob) !== undefined;
            if (!this.canExportChecked) {
                var l = document.createElement('a');
                this.canExportChecked = l.download !== undefined;
            }
        }

        return this.canExportChecked;
    },

    toggleEnabled: function () {
        $(this.ui.btnSave).attr('disabled', this.data.isEmpty() || !this.canExport() ? 'true' : null);
        $(this.ui.btnSaveCSV).attr('disabled', this.data.isEmpty() || !this.canExport() ? 'true' : null);
        this.view.removeDisabledTooltips();
    },

    exportCSV: function () {
        var content = ChartsExport.BuildCSVContent(this.data);
        var self = this;
        ChartsExport.CreateDownloadLink(
            content,
            'chart_' + Misc.timestampFormat(new Date()) + '.csv',
            'text/csv;charset=utf-8;',
            undefined,
            function () {
                self.canExportChecked = false;
                self.toggleEnabled();
            }
        );
    },

    createDownload: function (content, filename, type, canvas) {},

    export: function () {
        var valueWindows = this.chartView.getValueWindows();
        var index = 0;
        var self = this;

        var changeHeight = $(this.view.regions.chartContainer).height() < this.minHeight;
        var changeWidth = $(this.view.regions.chartContainer).width() < this.minWidth;

        if (changeWidth) $(this.view.regions.chartContainer).css('width', '' + this.minWidth + 'px');

        if (changeHeight) this.chartView.updateHeight(undefined, this.minHeight);

        this.canvases = [];
        this.foreachCharts(function (key, g) {
            g.resize();
            this.chartView.setValueWindows(valueWindows, key);
            this.canvases.push(Dygraph.Export.asCanvas(g));
        });

        var img = document.createElement('img');
        $('body').after(img);
        $(img).css('display', 'none');
        img.src = this.drawChart();

        ChartsExport.CreateDownloadLink(
            img.src,
            'chart_' + Misc.timestampFormat(new Date()) + '.png',
            'image/png',
            this.completeCanvas,
            function () {
                self.canExportChecked = false;
                self.toggleEnabled();
            }
        );

        // remove dummy image
        $(img).remove();

        if (changeWidth || changeHeight) {
            $(this.view.regions.chartContainer).css('width', '100%');
            this.chartView.updateHeight();
            this.foreachCharts(function (key, g) {
                g.resize();
                this.chartView.setValueWindows(valueWindows, key);
            });
        }
    },

    getCaption: function () {
        var range = this.getDateWindow();
        range = moment(range[0]).format(this.view.rangeFormat) + ' - ' + moment(range[1]).format(this.view.rangeFormat);
        var caption = this.charts.series.getCaption();
        caption += '' + (caption ? ': ' : '') + range;
        return caption;
    },

    drawChart: function () {
        var self = this;
        var d = document.createElement('canvas');
        var ctx = d.getContext('2d');
        // calculate width and height
        var h = this.headingHeight;
        var w = 0;
        var y = h;

        _.each(this.canvases, function (c) {
            h = h + c.height;
            w = Math.max(w, c.width);
        });

        d.width = w;
        d.height = h;
        this.completeCanvas = d;

        _.each(this.canvases, function (c) {
            ctx.drawImage(c, 0, y);
            y = y + c.height;
        });

        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, d.width, this.headingHeight);
        ctx.font = this.headingFont;
        var caption = this.caption;
        this.filename = 'chart.png';
        var textX = (d.width - ctx.measureText(caption).width) / 2;
        ctx.fillStyle = 'black';
        ctx.fillText(caption, textX, this.headingHeight - this.headingMargin);

        var result = d.toDataURL('image/png');
        return result;
    },
});

ChartsExport.BuildCSVContent = function (data) {
    // determine units for each column
    var units = [];
    _.each(data.selectedSeries, function (s, i) {
        var unitCount = {};
        _.each(data.rawData, function (row) {
            v = Misc.getValueDisplayInfos(row[i + 1], s.type, s.format, s.unit, s.display_unit, s.is_unit_fixed);
            unitCount[v.unit] = unitCount[v.unit] ? unitCount[v.unit] + 1 : 1;
        });

        var maxUnit = _.max(
            Misc.selectWhere(_.pairs(unitCount), function (a) {
                return a[0];
            }),
            function (x) {
                return x[1];
            }
        );

        units[i] = maxUnit[0];
    });

    var globalInterpolationMode = i18n.TR('unbekannt');
    if (data.rawData.length > 2) {
        var delta = data.rawData[1][0] - data.rawData[0][0];
        globalInterpolationMode = delta == 60 ? undefined : i18n.TR('berechnet');
    }

    var content = '';
    _.each(data.rawData, function (row, rowIdx) {
        var interpolated = -1;
        if (data.rawDataInterpolated) {
            interpolated = data.rawDataInterpolated[rowIdx];
        }

        var tmp = [];
        _.each(row, function (value, i) {
            pushValueState = function () {
                // do nothing for first entry (= timestamp)
                if (i == 0) {
                    return;
                }

                // no value? -> unknown
                if (_.isNull(value)) {
                    tmp.push(i18n.TR('unbekannt'));
                    return;
                }

                var valueBit = 1 << (i - 1);
                var isInterpolated = interpolated == -1 ? true : (interpolated & valueBit) != 0;

                tmp.push(isInterpolated ? i18n.TR('berechnet') : globalInterpolationMode || i18n.TR('gemessen'));
            };

            if (value !== null) {
                var valueStr = value.toLocaleString();

                s = data.selectedSeries[i - 1];
                if (s) {
                    valueUnit = Misc.getValueDisplayInfos(value, s.type, s.format, s.unit, units[i - 1], true);

                    valueStr = Misc.isFloat(valueUnit.value)
                        ? parseFloat(valueUnit.value).toLocaleString()
                        : valueUnit.value;
                }
                tmp.push(valueStr);
            } else tmp.push('');

            pushValueState();
        });

        tmp[0] = moment(new Date(row[0] * 1000)).format('DD.MM.YYYY HH:mm:ss');
        tmp = Misc.quoteCSVrecord(tmp);
        content += tmp.join(';') + '\n';
    });

    var header = [i18n.TR('Zeit')];
    _.each(data.selectedSeries, function (s, i) {
        header.push(s.label + (units[i] ? ' [' + units[i] + ']' : ''));
        header.push(i18n.TR('Status'));
    });
    header = Misc.quoteCSVrecord(header);
    content = header.join(';') + '\n' + content;

    return content;
};

ChartsExport.CreateDownloadLink = function (content, filename, type, canvas, onError) {
    var handleError = function () {
        if (onError) onError();
    };

    var blob;
    if (canvas && navigator.msSaveBlob) {
        blob = canvas.msToBlob();
        try {
            tmp = window.navigator.msSaveBlob(blob, filename);
        } catch (exc) {
            handleError();
        }
        return;
    }

    blob = new Blob([content], { type: type });

    if (navigator && navigator.msSaveBlob) {
        try {
            tmp = window.navigator.msSaveBlob(blob, filename);
        } catch (exc) {
            handleError();
        }
    } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
            var url = canvas ? content : URL.createObjectURL(blob);

            link.download = filename;
            link.href = url;

            $('body').after(link);
            link.click();
            $(link).remove();
        }
    }
};

module.exports = ChartsExport;
